import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  loginRequest,
  silentRequest,
  tokenRequest,
} from "../../helpers/authConfig";
import { msalApp } from "../../services/GraphService";
import { authActions } from "../../store";
import { Button } from "reactstrap";

export default function LoginAAD() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { default: jwt_decode } = require("jwt-decode");

  useEffect(() => {
    var jwttoken = localStorage.getItem("jwtToken");
    if (jwttoken) {
      refreshToken(jwttoken);
    }
    getAccounts();
  }, []);

  const refreshToken = async (jwttoken) => {
    var now = new Date();
    var jwtDecoded = jwt_decode(jwttoken);
    var jwtDate = new Date(jwtDecoded.exp * 1000);
    if (now >= jwtDate) {
      var accessToken = await acquireToken();
      accessToken &&
        dispatch(
          authActions.refreshJwtByAad({
            email: accessToken.account.username,
            token: accessToken.accessToken,
          })
        );
    }
  };

  const isIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ") > -1;
    const msie11 = ua.indexOf("Trident/") > -1;
    return msie || msie11;
  };

  const getAccounts = () => {
    const currentAccounts = msalApp.getAllAccounts();
    if (currentAccounts === null) {
      console.warn("No accounts detected!");
      return;
    } else if (currentAccounts.length > 1) {
      console.warn("Multiple accounts detected.");
      const account = msalApp.getAccount({});
      msalApp.setActiveAccount(account);
    } else if (currentAccounts.length === 1) {
      const account = msalApp.getAccount({});
      msalApp.setActiveAccount(account);
    }
  };

  const handleResponse = (response) => {
    if (response !== null) {
      msalApp.setActiveAccount(response.account);
    } else {
      getAccounts();
    }
  };

  const acquireToken = async () => {
    silentRequest.account = msalApp.getAccount({});
    return msalApp.acquireTokenSilent(silentRequest).catch((error) => {
      console.warn(
        "silent token acquisition fails. acquiring token using interactive method"
      );
      if (error) {
        // fallback to interaction when silent call fails
        tokenRequest.account = msalApp.getAccount({});

        return msalApp
          .acquireTokenPopup(tokenRequest)
          .then(handleResponse)
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.warn(error);
      }
    });
  };

  const login = async () => {
    await msalApp.initialize();
    await msalApp.handleRedirectPromise();
    if (isIE()) {
      return msalApp.loginRedirect();
    }
    await msalApp
      .loginPopup(loginRequest)
      .then(handleResponse)
      .then(getUserProfile)
      .catch((err) => {
        console.log(err);
      });
  };

  const getUserProfile = async () => {
    var accessToken = await acquireToken();
    if (accessToken) {
      dispatch(
        authActions.loginWithAad({
          email: accessToken.account.username,
          token: accessToken.accessToken,
        })
      );
    }
  };

  return (
    <Button color="primary" type="button" size="md" onClick={login}>
      <i class="fas fa-sign-in-alt"></i>&nbsp; {t("login")}
    </Button>
  );
}
